// css =>
import "../../BaseStructure.css";
import Styled from "./OrderHistory.module.css";

// react =>
import { useState, useEffect, JSX } from "react";
import { useNavigate } from "react-router-dom";

// componenets =>
import Header from "../../Components/header/header.comp";
import MenuBar from "../../Components/menuBar/menuBar.comp";
import SpinnerBar from "../../Components/spinnerBar/spinnerBar.comp";
import LocationShow from "../../Components/locationShow/locationShow.comp";
import HeaderTittle from "../../Components/headerTittle/headerTittle.comp";
import FirstMenuBar from "../../Components/firstMenuBar/firstMenuBar.comp";
import MobileMenuBar from "../../Components/mobileMenuBar/mobileMenuBar.comp";
import PagePagination from "../../Components/pagePagination/pagePagination.comp";
import OrderHistoryBox from "../../Components/orderHistoryBox/orderHistoryBox.comp";

// API =>
import backEnd from "../../services/Api";
import { useUserStore } from "../../hooks/useUserStore";

// utils =>
import { formatPrice } from "../../utils/ChangePriceFormat";

// type =>
import { ORDER_HISTORY_RESPONSE, ORDER_HISTORY_ITEM, PRODUCT } from "./OrderHistoryType";

// context =>
import { useMessage } from "../../Contexts/MessageBoxContext";

function OrderHistory() {

    const pageSize = 20;
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [numberOfOrders, setNumberOfOrders] = useState<number>(0);

    const navigate = useNavigate();
    const { showMessage } = useMessage();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [ordersHistoryList, setOrdersHistoryList] = useState<ORDER_HISTORY_RESPONSE | null>(null);

    useEffect(() => {
        document.title = "ویدوک | تاریخچه سفارشات";

        setIsLoading(true);
        backEnd.get(`orders/items?order__order_status=Order_delivery&page=${ currentPage }`).then(( result ) => {
            setOrdersHistoryList(result.data);
            setNumberOfOrders(result.data.count);

            setIsLoading(false);
        }).catch(( error ) => {
            let errorMessage = "خطای غیرمنتظره‌ای رخ داد.";

            if (error.response) {
                const status = error.response.status;

                switch (status) {
                    case 400:
                        errorMessage = "درخواست ارسال شده نامعتبر است.";
                        break;

                    case 401:    
                    case 403:
                        useUserStore.getState().setUser(null);
                        localStorage.removeItem("user-storage");

                        errorMessage = "لطفاً ابتدا وارد حساب کاربری خود شوید یا ثبت نام کنید!";
                        navigate("/sign-in");
                        break;

                    case 404:
                        errorMessage = "سفارشی برای شما پیدا نشد.";
                        break;

                    case 429:
                        errorMessage = "تعداد درخواست‌ها زیاد است. لطفاً کمی بعد دوباره تلاش کنید.";
                        break;

                    case 500:
                        errorMessage = "خطایی در سرور رخ داده است. لطفاً بعداً تلاش کنید.";
                        break;

                    case 503:
                        errorMessage = "سرور موقتاً در دسترس نیست.";
                        break;

                    default:
                        errorMessage = "خطایی رخ داده است. لطفاً دوباره تلاش کنید.";
                }
            } else if (error.request) {
                errorMessage = "اتصال به سرور برقرار نشد. اینترنت خود را بررسی کنید.";
            } else {
                errorMessage = "مشکلی در ارسال درخواست به وجود آمد.";
            }

            setIsLoading(false);
            showMessage("error", errorMessage);
        });
    }, [currentPage]);

    return (
        <>
            <Header />
            <MobileMenuBar key={ 0 } isAuthenticated />
            <LocationShow key={ 1 } pathName="حساب کاربری من" />
            <FirstMenuBar key={ 2 } />
            <HeaderTittle key={ 3 } headerTittleList={["عکس محصول", "نام محصول", "کد محصول", "رنگ", "تعداد", "قیمت", "", ""]} />

            <div>
                {
                    isLoading ? (
                        <div className="row">
                            <div className="col-12 SpinnerBarFrame">
                                <SpinnerBar />
                            </div>
                        </div>
                    ) : !ordersHistoryList?.results || ordersHistoryList.results.length === 0 ? (
                        <p className="EmptyText">هیچ تاریخچه‌ای وجود ندارد</p>
                    ) : (
                        ordersHistoryList.results.map((item: ORDER_HISTORY_ITEM) => {
                            const product: PRODUCT = item.product;

                            return (
                                <OrderHistoryBox
                                    key={ item.id }
                                    orderedItemKey={ item.id }
                                    orderedItemName={ product.full_name }
                                    orderItemCount={ item.quantity }
                                    orderedItemPic={ product.thumbnail }
                                    orderedItemColor={ item.item_color?.color_code || '#000000' }
                                    orderedItemPrice={ formatPrice(product.price) }
                                    orderedItemCode={ product.id }
                                />
                            );
                        })
                    )
                }
            </div>

            <br /><br /><br />

            <div className="row" id={Styled.PagePaginationFrame}>
                <PagePagination
                    currentPage={ currentPage }
                    totalCount={ numberOfOrders }
                    pageSize={ pageSize }
                    onPageChange={(page) => setCurrentPage(page)}
                />
            </div>

            <br /><br /><br />

            <MenuBar />
        </>
    );
}

export default OrderHistory;
